export default __webpack_public_path__ + "static/media/blocked.02d1cedb.svg";